import LandingPageBlurb from '@/app/components/LandingPage/LandingPageBlurb';

const BusinessHowWeCanHelp = () => {
  return (
    <section
      className="flex h-[448px] flex-row items-center justify-around px-5 pt-10"
      data-cy="business-how-we-can-help"
    >
      <LandingPageBlurb
        description={{
          alignment: 'top',
          key: 'business_how_we_can_help_description',
        }}
        title={{
          colEnd: { lg: 11, xl: 9, xxl: 8 },
          key: 'business_how_we_can_help_title',
          multiline: true,
        }}
      />
    </section>
  );
};

export default BusinessHowWeCanHelp;
